import { useLocalSearchParams } from 'expo-router';
import { questionModuleQuery, useModule } from 'system/structure-modules';
import { ParamProvider } from 'util/params';

export default function SpaceIndexScreen() {
    const { commentID } = useLocalSearchParams<'/[siloKey]/question/[instanceKey]', { commentID: string }>();
    const { QuestionScreen } = useModule(questionModuleQuery);
    return (
        <ParamProvider instanceParams={{ commentID }}>
            <QuestionScreen />
        </ParamProvider>
    );
}
